/**
 * Cross-cutting client state for the auth feature.
 *
 * Zustand is intentionally small here - we only keep what's truly app-
 * wide (the current user + a boolean for "are we still resolving").
 * Per-form state lives in react-hook-form, server data lives in
 * TanStack Query, and tokens live inside Amplify's storage. The store
 * just memoises the resolved AuthUser so we don't refetch on every
 * render.
 */
import { create } from 'zustand';

import type { AuthUser } from '../types';

interface AuthState {
  user: AuthUser | null;
  isLoading: boolean;
  setUser: (user: AuthUser | null) => void;
  setLoading: (isLoading: boolean) => void;
  reset: () => void;
}

export const useAuthStore = create<AuthState>((set) => ({
  user: null,
  isLoading: true,
  setUser: (user) => set({ user, isLoading: false }),
  setLoading: (isLoading) => set({ isLoading }),
  reset: () => set({ user: null, isLoading: false }),
}));
